import type { ReactNode, FC } from "react";

import styled from "styled-components";

import { colorsPalettes, setFont } from "@similarweb/styles";

import type { ITotalVisitsSectionData } from "../../../../app/pages/workspace/marketing/pages/MarketingOverview.types";
import type { IMarketingMixTableRow } from "../MarketingMixTable/src/MarketingMixTable.types";

export const StyledCell = styled.div`
    box-sizing: border-box;
    height: 48px;
    line-height: 48px;
    display: flex;
    align-content: center;
    color: ${colorsPalettes.carbon[500]};
    border-bottom: 1px solid ${colorsPalettes.carbon[50]};
    ${setFont({ $size: 14 })};
    .swReactTableCell & {
        line-height: 20px;
    }
`;
type Item = IMarketingMixTableRow | ITotalVisitsSectionData;
interface IDefaultCellProps {
    value?: number;
    children?: ReactNode;
    className?: string;
    cellEnter?: (item: Item | undefined) => void;
    cellLeave?: (item: Item | undefined) => void;
    row?: Item;
    selectedTableRow?: Item;
}

export const DefaultCell: FC<IDefaultCellProps> = (props) => {
    const { className, children, cellEnter = () => {}, cellLeave = () => {}, row, selectedTableRow, value } = props;
    return (
        <StyledCell
            className={selectedTableRow && selectedTableRow === row ? `selected ${className}` : className}
            onMouseEnter={() => {
                cellEnter(row);
            }}
            onMouseLeave={() => {
                cellLeave(row);
            }}
        >
            {children || value}
        </StyledCell>
    );
};
